import React, {FC, SyntheticEvent} from 'react';
import './style.scss';

interface ISearch {
    value: string,
    onChange: any
}

const Search: FC<ISearch> = ({value, onChange}) => {

    const onChangeHandler = (event: SyntheticEvent) => {
      onChange((event.target as HTMLInputElement).value)
    };

    return (
        <input
            className="input__search"
            placeholder="Поиск"
            value={value}
            onChange={onChangeHandler}
        />
    )
};

export default Search;
